// extracted by mini-css-extract-plugin
export default {"address-form":"AddressForm_address-form__QfFBK","address-form-btn-container":"AddressForm_address-form-btn-container__0IWdU","address-form-btn":"AddressForm_address-form-btn__9FYYz"};